import React from 'react';

type Props = {
  show: boolean;
  value: string;
  onChange: (v: string) => void;
  onClose: () => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
};

export default function EditCommentModal({ show, value, onChange, onClose, onSubmit }: Props) {
  if (!show) return null;
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-xl w-full">
        <form onSubmit={onSubmit} className="p-6 space-y-4">
          <h2 className="text-2xl font-bold text-gray-900">Editar Comentário</h2>
          <textarea
            value={value}
            onChange={(e) => onChange(e.target.value)}
            rows={4}
            className="w-full p-2 border rounded"
            placeholder="Atualize seu comentário..."
          />
          <div className="flex justify-end space-x-4">
            <button type="button" onClick={onClose} className="px-6 py-2 border rounded">Cancelar</button>
            <button type="submit" className="px-6 py-2 bg-indigo-600 text-white rounded">Salvar</button>
          </div>
        </form>
      </div>
    </div>
  );
}